const Upload = ({ size=24, color="#3B82F6", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        {...props} // Allows you to override width, height, etc.
    >
        <path
            d="M12 16V4M12 4L8 8M12 4L16 8M4 20H20"
            fill={color}
            // strokeWidth="2"
            // strokeLinecap="round"
            // strokeLinejoin="round"
        />
    </svg>
);

export default Upload;
